export default __webpack_public_path__ + "static/media/facebook-square.d319109b.svg";